import React, { createContext, useContext, useState, FC } from "react";
import en from "./en_EN";
import pl from "./pl_PL";

const locales: Record<string, any> = {
  en,
  pl,
};

interface LanguageContextProps {
  lang: string;
  setLang: (lang: string) => void;
  labels: typeof locales;
}

function getOfficeLocale(): string {
  // Office.context.displayLanguage returns locale like 'en-US'
  // Fallback to 'en' if Office is not available

  // eslint-disable-next-line no-undef
  if (typeof Office !== "undefined" && Office.context && Office.context.displayLanguage) {
    // eslint-disable-next-line no-undef
    return Office.context.displayLanguage.split("-")[0];
  }
  return "pl";
}

function getLocaleStrings() {
  const locale = getOfficeLocale();
  return locales[locale] || locales["pl"];
}

function getUserLocaleStrings(usersLanguage: string) {
  if (usersLanguage) {
    return locales[usersLanguage] || locales["pl"];
  } else {
    return getLocaleStrings();
  }
}

export const LanguageContext = createContext<LanguageContextProps>({
  lang: "pl",
  setLang: () => {},
  labels: locales.pl,
});

type Props = {
  children?: React.ReactNode;
};

export const LanguageProvider: FC<Props> = ({ children }) => {
  const [lang, setLang] = useState(getOfficeLocale());
  const labels = getUserLocaleStrings(lang) || locales.en;
  return <LanguageContext.Provider value={{ lang, setLang, labels }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = (): LanguageContextProps => useContext(LanguageContext);
